import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="turbo"
export default class extends Controller {

  static targets = ['frame'];

  connect() {
    this.element.dataset.action += ' turbo:load@document->turbo#loaded';

    Turbo.StreamActions.redirect = function () {
      let turboFrame = document.querySelector('.modal turbo-frame')
      if (turboFrame) turboFrame.ariaBusy = true;
      window.location.href = this.target;
    };

    Turbo.StreamActions.reload = function () {
      let turboFrame = document.querySelector('.modal turbo-frame')
      if (turboFrame) turboFrame.ariaBusy = true;
      window.location.reload();
    };

    Turbo.StreamActions.reload_modal = function () {
      let turboFrame = document.querySelector('.modal turbo-frame')
      if (turboFrame) {
        turboFrame.ariaBusy = true;
        turboFrame.src = turboFrame.src
      } else {
        window.location.reload();
      }
    };
  }

  loaded() {
    document.body.dataset.turboLoaded = true
  }

  emptyFrame(e) {
    e.preventDefault()
    e.target.closest('turbo-frame').innerHTML = '';
  }

  frameTargetConnected(frame) {
    this.reloadFrame(frame, 5000);
  }

  reloadFrame(frame, timeout) {
    setTimeout(() => {
      let src = frame.src;

      if (!src) src = location.href;

      frame.src = src.split('?')[0] + '?r=' + Math.random();

      this.reloadFrame(frame, timeout);
    }, timeout);
  }
}